import { styled } from 'styled-components'

export const IconWrapper = styled.span`
  color: inherit;
`
